<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-sheet class="card-rounded">
                <v-row no-gutters>
                    <!-- ระดับชั้นที่ต้องการสมัคร -->
                    <v-col cols="12" class="pa-4">
                        <v-row
                            no-gutters
                            justify="space-between"
                            class="mb-3"
                            align="center"
                        >
                            <span class="header-text">{{ $t('message.adminPage.remark.remarkHeader') }}</span>
                            <v-btn
                                color="primary"
                                small
                                text
                                class="underline-text"
                                :disabled="!noteChange"
                                @click="onNoteSave"
                            >
                                {{ $t('message.adminPage.remark.save') }}
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="px-4">
                        <v-textarea
                            color="#D7D6D8"
                            outlined
                            :placeholder="$t('message.adminPage.remark.remarkText')"
                            v-model="note"
                            rows="4"
                            row-height="30"
                            @change="noteUpdate"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import * as services from "@/services"

export default {
    props: {
        applicantInfo: Object,
        currentStep: String,
    },
    mounted() {
        this.retrievedData();
    },
    data() {
        return {
            applicant: {},
            noteChange: false,
            note: null,
        };
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
            this.note = this.applicant?.healthInfo?.notation
        },
        noteUpdate() {
            this.noteChange = true;
        },
        async onNoteSave() {
            this.noteChange = false;
            
            await services.updateStudentNotation(this.applicant.id, {notation: this.note})
            this.$emit("onNoteSave");
        },
    },
};
</script>

<style scoped lang="scss">
.underline-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    /* identical to box height, or 133% */

    text-decoration-line: underline;

    /* Primary/Primary 500 - FF9800 */

    /* color: #ff9800; */
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
